export const TABLE_DATA = [
	{
		monday: 'Alex',
		tuesday: 'Anna',
		wednesday: 'Amalia',
		thursday: 'Arthur',
		friday: 'Alex',
		saturday: 'Andrea',
		sunday: 'Arnold',
	},
	{
		monday: 'Helena',
		tuesday: 'Fabian',
		wednesday: 'Marie',
		thursday: 'Ben',
		friday: 'Marcus',
		saturday: 'Alex',
		sunday: 'Marcus',
	},
	{
		monday: 'Fabian',
		tuesday: 'Helena',
		wednesday: 'Fabian',
		thursday: 'Maya',
		friday: 'Ben',
		saturday: 'Alex',
		sunday: 'Helena',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Finn',
		tuesday: 'Roger',
		wednesday: 'Christian',
		thursday: 'Caspar',
		friday: 'David',
		saturday: 'Bernard',
		sunday: 'Anna',
	},
	{
		monday: 'Alex',
		tuesday: 'Anna',
		wednesday: 'Amalia',
		thursday: 'Arthur',
		friday: 'Alex',
		saturday: 'Andrea',
		sunday: 'Arnold',
	},
	{
		monday: 'Helena',
		tuesday: 'Fabian',
		wednesday: 'Marie',
		thursday: 'Ben',
		friday: 'Marcus',
		saturday: 'Alex',
		sunday: 'Marcus',
	},
	{
		monday: 'Fabian',
		tuesday: 'Helena',
		wednesday: 'Fabian',
		thursday: 'Maya',
		friday: 'Ben',
		saturday: 'Alex',
		sunday: 'Helena',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Finn',
		tuesday: 'Roger',
		wednesday: 'Christian',
		thursday: 'Caspar',
		friday: 'David',
		saturday: 'Bernard',
		sunday: 'Anna',
	},
	{
		monday: 'Alex',
		tuesday: 'Anna',
		wednesday: 'Amalia',
		thursday: 'Arthur',
		friday: 'Alex',
		saturday: 'Andrea',
		sunday: 'Arnold',
	},
	{
		monday: 'Helena',
		tuesday: 'Fabian',
		wednesday: 'Marie',
		thursday: 'Ben',
		friday: 'Marcus',
		saturday: 'Alex',
		sunday: 'Marcus',
	},
	{
		monday: 'Fabian',
		tuesday: 'Helena',
		wednesday: 'Fabian',
		thursday: 'Maya',
		friday: 'Ben',
		saturday: 'Alex',
		sunday: 'Helena',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Finn',
		tuesday: 'Roger',
		wednesday: 'Christian',
		thursday: 'Caspar',
		friday: 'David',
		saturday: 'Bernard',
		sunday: 'Anna',
	},
	{
		monday: 'Alex',
		tuesday: 'Anna',
		wednesday: 'Amalia',
		thursday: 'Arthur',
		friday: 'Alex',
		saturday: 'Andrea',
		sunday: 'Arnold',
	},
	{
		monday: 'Helena',
		tuesday: 'Fabian',
		wednesday: 'Marie',
		thursday: 'Ben',
		friday: 'Marcus',
		saturday: 'Alex',
		sunday: 'Marcus',
	},
	{
		monday: 'Fabian',
		tuesday: 'Helena',
		wednesday: 'Fabian',
		thursday: 'Maya',
		friday: 'Ben',
		saturday: 'Alex',
		sunday: 'Helena',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Finn',
		tuesday: 'Roger',
		wednesday: 'Christian',
		thursday: 'Caspar',
		friday: 'David',
		saturday: 'Bernard',
		sunday: 'Anna',
	},
	{
		monday: 'Alex',
		tuesday: 'Anna',
		wednesday: 'Amalia',
		thursday: 'Arthur',
		friday: 'Alex',
		saturday: 'Andrea',
		sunday: 'Arnold',
	},
	{
		monday: 'Helena',
		tuesday: 'Fabian',
		wednesday: 'Marie',
		thursday: 'Ben',
		friday: 'Marcus',
		saturday: 'Alex',
		sunday: 'Marcus',
	},
	{
		monday: 'Fabian',
		tuesday: 'Helena',
		wednesday: 'Fabian',
		thursday: 'Maya',
		friday: 'Ben',
		saturday: 'Alex',
		sunday: 'Helena',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Hong',
		tuesday: 'Alex',
		wednesday: 'Kevin',
		thursday: 'Maya',
		friday: 'Fabian',
		saturday: 'Helena',
		sunday: 'Alex',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Samuel',
		tuesday: 'Selena',
		wednesday: 'Sandra',
		thursday: 'Salim',
		friday: 'Robert',
		saturday: 'Richard',
		sunday: 'Pamela',
	},
	{
		monday: 'Finn',
		tuesday: 'Roger',
		wednesday: 'Christian',
		thursday: 'Caspar',
		friday: 'David',
		saturday: 'Bernard',
		sunday: 'Anna',
	},
];
export type TableDataType = (typeof TABLE_DATA)[0];
